import Model, { attr, belongsTo } from "@ember-data/model";

export default class LoadBalancerCertificateModel extends Model {
  @attr name;
  @attr certificate;

  @belongsTo("load-balancer", { async: false, inverse: "certificates" }) loadBalancer;
}
